export default "__VITE_ASSET__D$h53HYG__"